import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
class BranchAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            formData: {
                name: ''
            }
        }
    }

    handleChance = (e) => {
        const { id, value } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: value
            }
        }))
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;
        const branchFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => {
            branchFormData.append(key, formData[key]);
        });
        try {
            const response = await apiCall('business/branches/add', 'post', branchFormData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message);
        } catch (e) {
            this.setState({ loading: false });

        }

    }
    render() {
        const { loading } = this.state;
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Şube Ekle"
                            Breadcrumb={[
                                { name: "Şubeler", navigate: "branches" },
                                { name: "Yeni Şube", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="card">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <input
                                                        id="name"
                                                        className="form-control"
                                                        placeholder="Şube Adı"
                                                        type="text"
                                                        onChange={this.handleChance}
                                                    />
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                {loading ? (
                                                    <button className="btn btn-outline-primary btn-block" disabled={true} style={{ textAlign: "-webkit-center" }}>
                                                        Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"></ReactLoading>
                                                    </button>
                                                ) :
                                                    <button className="btn btn-outline-primary btn-block" type="submit">
                                                        Kaydet
                                                    </button>}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withRouter(connect(mapStateToProps, {})(BranchAdd));
